import * as types from './actiontypes';

export function getEYUsersList(url, resource) {
	return {
		type: types.GET_EYUSERS,
		meta: {
			api: {
				url,
				method: 'GET',
				data: {
					resource
				}
			}
		}
	};
}
